import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import * as React from "react";
import { patients, rooms, therapists, treatments } from "./data";
import { useSelector, useDispatch } from "react-redux";
import { calendaeLocationDetails } from "../../JobOpportunity/action";
import useConfiguration from "../../../hooks/useConfiguration";
import { FieldWrapper } from "@progress/kendo-react-form";
import { Checkbox, Input } from "@progress/kendo-react-inputs";
import moment from "moment";
import {
  updateEditDayDate,
  updateKendoStartEndDay,
} from "../../JobOpportunity/slice";
import { RRule } from "rrule";
import * as Toasts from "../../common/Toastify";
import { formatNumberWithCommas } from "../../../helpers/regEx";
export const TitleEditor = (props) => {
  const handleChange = (event) => {
    if (props.onChange) {
      props.onChange.call(undefined, {
        value: event.value.id,
      });
    }
  };
  return (
    <DropDownList
      onChange={handleChange}
      value={patients.find((p) => p.id === props.value)}
      data={patients}
      dataItemKey={"id"}
      textField={"name"}
    />
  );
};
export const TreatmentEditor = (props) => {
  const handleChange = (event) => {
    if (props.onChange) {
      props.onChange.call(undefined, {
        value: event.value.value,
      });
    }
  };
  return (
    <DropDownList
      onChange={handleChange}
      value={treatments.find((t) => t.value === props.value)}
      data={treatments}
      dataItemKey={"value"}
      textField={"text"}
    />
  );
};
export const TherapistEditor = (props) => {
  const handleChange = (event) => {
    if (props.onChange) {
      props.onChange.call(undefined, {
        value: event.value.value,
      });
    }
  };
  return (
    <DropDownList
      disabled={true}
      onChange={handleChange}
      value={therapists.find((t) => t.value === props.value)}
      data={therapists}
      dataItemKey={"value"}
      textField={"name"}
    />
  );
};
export const RoomEditor = (props) => {
  const handleChange = (event) => {
    if (props.onChange) {
      props.onChange.call(undefined, {
        value: event.value.id,
      });
    }
  };
  return (
    <DropDownList
      onChange={handleChange}
      value={rooms.find((r) => r.id === props.value)}
      data={rooms}
      dataItemKey={"id"}
      textField={"title"}
    />
  );
};

export const Location = (props) => {
  const masterData = useSelector((state) => state.jobOpportunity.masterData);

  //console.log(masterData?.allJobLocations);
  const handleChange = (event) => {
    console.log(event);
    if (props.onChange) {
      props.onChange.call(undefined, {
        value: event.value.id,
      });
    }
  };

  return (
    <DropDownList
      data={masterData?.allJobLocations}
      onChange={handleChange}
      value={masterData?.allJobLocations.find((t) => t.id === props.value)}
      textField="name"
      dataItemKey="id"
      style={{
        width: "600px",
        background: "#fff",
      }}
      placeholder="Please select ..."
    />
  );
};

export const Approver = (props) => {
  const masterData = useSelector((state) => state.jobOpportunity.masterData);
  const dispatch = useDispatch();
  const config = useConfiguration();
  //console.log(masterData?.allJobLocations);
  React.useEffect(() => {
    if (props?.locationId && config.baseUrl) {
      dispatch(calendaeLocationDetails(config.baseUrl, props?.locationId));
    }
    //console.log(props, '000000000000000000000000000000000000000');
  }, [config.baseUrl]);
  const handleChange = (event) => {
    // console.log(event);
    if (props.onChange) {
      props.onChange.call(undefined, {
        value: event.value?.map((item) => item.id),
      });
    }
  };

  const getSelectedValue = (value) => {
    //  console.log(value, '==================');
    // console.log(masterData?.allJobLocationApprovers.filter(o1 =>value.some(o2 => o1.id === o2)));
    const includes = masterData?.calendarobLocationApprovers?.filter((o1) =>
      value?.some((o2) => o1.id === o2)
    );
    return includes;
  };

  return (
    <MultiSelect
      data={masterData?.calendarobLocationApprovers}
      onChange={handleChange}
      value={getSelectedValue(props.value)}
      textField="name"
      dataItemKey="id"
      style={{
        width: "300px",
        background: "#fff",
      }}
      placeholder="Please select ..."
    />
  );
};

export const ContactPerson = (props) => {
  const masterData = useSelector((state) => state.jobOpportunity.masterData);

  const dispatch = useDispatch();
  const config = useConfiguration();

  React.useEffect(() => {
    if (props?.locationId && config.baseUrl) {
      dispatch(calendaeLocationDetails(config.baseUrl, props?.locationId));
    }
    // console.log(props, '000000000000000000000000000000000000000');
  }, [config.baseUrl]);
  //console.log(masterData?.allJobLocations);
  const handleChange = (event) => {
    //  console.log(event);
    if (props.onChange) {
      props.onChange.call(undefined, {
        value: event.value?.map((item) => item.id),
      });
    }
  };

  const getSelectedValue = (value) => {
    const includes = masterData?.calendarJobLocationContactPersons?.filter(
      (o1) => value?.some((o2) => o1.id === o2)
    );
    return includes;
  };

  return (
    <MultiSelect
      data={masterData?.calendarJobLocationContactPersons}
      onChange={handleChange}
      value={getSelectedValue(props.value)}
      textField="name"
      dataItemKey="id"
      style={{
        width: "300px",
        background: "#fff",
      }}
      placeholder="Please select ..."
    />
  );
};

export const FormCheckbox = (fieldRenderProps) => {
  const {
    validationMessage,
    touched,
    id,
    valid,
    disabled,
    hint,
    optional,
    label,
    onChange,
    startDate,
    endDate,
    defaultStartDate,
    defaultEndDate,
    value,
    ...others
  } = fieldRenderProps;
  const data = useSelector((store) => store.jobOpportunity);
  const dispatch = useDispatch();
  const getNewDate = (dateStr) => {
    const [year, month, day] = dateStr.split("-");
    return new Date(year, month - 1, day);
  };
  // const getNewTime = (timeStr) => {
  //   const [hours,minutes,seconds] = timeStr.split(":")
  //     return {hours,minutes,seconds}
  // }
  const getExpectedDateTime = (date, hours, minutes, seconds) => {
    return new Date(date.setHours(hours, minutes, seconds));
  };
  const getExpectedObj = (
    editTempDate,
    exceptionTimeFormat,
    checkStartDate,
    checkEndDate
  ) => {
    // const exceptionObj =  getNewTime(data?.shift?.startTime?.id)
    const [exceptHours, exceptMinutes, exceptSeconds] =
      exceptionTimeFormat.split(":");
    const endTimeHour =
      checkStartDate.valueOf() === checkEndDate.valueOf()
        ? endDate.getHours()
        : endDate.getHours() + 24;
    const expectObj = {
      Start: getExpectedDateTime(
        new Date(editTempDate),
        startDate.getHours(),
        startDate.getMinutes(),
        startDate.getSeconds()
      ),
      End: getExpectedDateTime(
        new Date(editTempDate),
        endTimeHour,
        endDate.getMinutes(),
        endDate.getSeconds()
      ),
      ExceptionDate: getExpectedDateTime(
        new Date(editTempDate),
        exceptHours,
        exceptMinutes,
        exceptSeconds
      ),
    };
    return expectObj;
  };

  const findBetweenDays = (data, startDate, endDate, exceptionDate) => {
    // console.log({data,startDate,endDate});
    // let dates = [];
    //  const rule1 = RRule.fromString(
    //   `DTSTART:${moment(new Date(startDate)).utc().format('YYYYMMDDTHHmmss')}Z;
    //   RRULE:${data?.rrurle};BYDAY=${moment(new Date(startDate)).utc().format('dddd').slice(0,2).toUpperCase()}
    //   `
    // )
    //  const rule2 = RRule.fromString(
    //   `DTSTART:${moment(endDate).utc().format('YYYYMMDDTHHmmss')}Z;
    //   RRULE:${data?.rrurle};BYDAY=${moment(new Date(endDate)).utc().format('dddd').slice(0,2).toUpperCase()}
    //   `
    // )
    // rule1 && rule2 && rule1.all().forEach((_,index) => {
    //   dates.push({Start:rule1.all()[index],End:rule2.all()[index],ExceptionDate: new Date(moment(moment(rule1.all()[index]).format("YYYY-MM-DD") + ' ' + data?.shift.startTime.name,'YYYY-MM-DD H:mm A')) })
    // })
    // console.log({dates});
    // if(dates?.length){
    //   dispatch(updateEditDayDate(JSON.parse(JSON.stringify(dates))))
    // }
    let dateList = [];
    const everyDateFind = startDate && moment(startDate).format("YYYY-MM-DD")
    const editEndDate = getNewDate(data?.shift?.endDate);
    const findStartDate = startDate && moment(startDate).format("YYYY-MM-DD");
    const editTempDate = findStartDate && getNewDate(findStartDate);
    const findEndDate = endDate && moment(endDate).format("YYYY-MM-DD");
    const checkStartDate = findStartDate && getNewDate(findStartDate);
    const checkEndDate = findEndDate && getNewDate(findEndDate);
    // const editTempDate = new Date(new Date(startDate).getFullYear(),new Date(startDate).getMonth(),new Date(startDate).getDay());
    const everyDay = new RegExp(
      moment(new Date(everyDateFind)).utc().format("dddd").charAt(0).toUpperCase() +
        moment(new Date(everyDateFind)).utc().format("dddd").slice(1, 3)
    );
    // console.log({everyDay});
    while (editTempDate.valueOf() <= editEndDate.valueOf()) {
      if (everyDay.test(editTempDate.toDateString())) {
        let expetctedObj = {};
        if (data?.shift?.startTime?.id && editTempDate) {
          expetctedObj = getExpectedObj(
            editTempDate,
            data?.shift?.startTime?.id,
            checkStartDate,
            checkEndDate
          );
        }
        dateList.push(expetctedObj);
      }
      editTempDate.setDate(editTempDate.getDate() + 1);
    }
    if (dateList?.length) {
      dispatch(updateEditDayDate(JSON.parse(JSON.stringify(dateList))));
    }
    console.log({ dateList });
  };
  const handleChange = (event) => {
    const { name, value } = event.target;
    if (fieldRenderProps.onChange) {
      // moment(startDate).format("hh:mm A") === moment(defaultDate.current).format("hh:mm A")
      //  if((startDate.toString() !== defaultStartDate.current.toString() || endDate.toString() !== defaultEndDate.current.toString())){
      //    fieldRenderProps.onChange.call(undefined, {
      //     value,
      //     });
      //   } else {
      //     Toasts.error("Please change shift time")
      //     return
      //   }
      fieldRenderProps.onChange.call(undefined, {
        value,
      });
    }
  };
  React.useEffect(() => {
    if (value && data?.rrurle && startDate && endDate) {
      findBetweenDays(data, startDate, endDate);
    } else {
      dispatch(updateEditDayDate([]));
    }
  }, [value, startDate, endDate]);
  return (
    <FieldWrapper>
      <Checkbox
        label={label}
        // valid={valid}
        id={id}
        checked={value}
        // disabled={disabled}
        onChange={handleChange}
        {...others}
      />
    </FieldWrapper>
  );
};

export const ShiftLength = (props) => {
  const aDayInMins = 24 * 60;
  const masterData = useSelector((state) => state.jobOpportunity.masterData);
  const prefferredShiftLength = masterData?.allPreferedShifts?.filter(length => length?.id <= aDayInMins)
  const handleChange = (event) => {
    if (props.onChange) {
      props.onChange.call(undefined, {
        value: event.value.id,
      });
    }
  };

  return (
    <DropDownList
      onChange={handleChange}
      value={masterData?.allPreferedShifts.find((t) => t.id === props.value)}
      data={prefferredShiftLength ?? masterData?.allPreferedShifts}
      dataItemKey={"id"}
      textField={"name"}
      style={{
        background: "#fff",
        border: `${props.valid === false ? "1px solid red" : ""}`,
      }}
    />
  );
};

export const AmountPerShift = (props) => {
  const handleChange = (event) => {
    if (props.onChange) {
      props.onChange.call(undefined, {
        value: event.target.value,
      });
    }
  };

  return (
    <Input
      name={"payRateOccurrenceAmount"}
      id="payRateOccurrenceAmount"
      value={props.value ? formatNumberWithCommas(props.value) : props.value}
      onChange={handleChange}
      // className="showDollar_input_default"
    />
  );
};
